/* --- STATE --- */

import { IFieldsByCompanies } from '../../Map/slice/types';
export interface CulturesState {
  cultures: ICulture[];
  loading: boolean;
  culturesList: {
    loading: boolean;
    cultures: ISortedListCulture;
  };
  cultureDetails: {
    loading: boolean;
    culturesArr: ICompanyCulture[];
    companyId: number | null;
  };
  createCulture: {
    loading: boolean;
  };
}

export interface ICulture {
  id: number;
  name: string;
  code: string;
  countryCode: string;
  color: string;
}

export interface ICultureVariation {
  id: number;
  name: string;
  culture: ICulture;
}

export interface ICompany {
  id: number;
  name: string;
  companyCode: string;
  city: string;
  accepted: boolean | null;
}

export interface ICompanyCulture {
  id: number;
  company: ICompany;
  harvest: number;
  area: number;
  culture: {
    id: number;
    name: string;
    code: string;
    countryCode: string;
    color: string;
  };
}

export interface ICultureListItem {
  cultureId: number;
  cultureName: string;
  harvest: number;
  area: number;
}

export interface ICompanyListItem {
  id: number;
  name: string;
  cultures: ICultureListItem[];
}

export interface ISortedListCulture {
  cultures: ICultureListItem[];
  companies: ICompanyListItem[];
}

export interface IHarvestObj {
  // company id : harvest value
  [companyId: number]: number | undefined;
}

export enum cultureFormValuesEnum {
  culture = 'culture',
  plannedHarvest = 'plannedHarvest',
}

/* --- PAYLOADS --- */
export interface IGetCompanyCultureByIdPayload {
  envId: number;
  cultureId: number;
  companyId: number;
}

export interface ICreateOrEditCulturePayload {
  isEdit: boolean;
  hiikoEnvironmentId: number;
  cultureId: number;
  companyId?: number | null;
  selectedFields: IFieldsByCompanies[];
  harvests: IHarvestObj;
}

export interface IGetCultureDetailsPayload {
  hiikoEnvironmentId: number;
  cultureId: number;
  companyId?: number;
  seasonId: number;
}

export interface ISetCultureDetailsPayload {
  companyId: number | null;
  culturesArr: ICompanyCulture[];
}

export interface IVariation {
  variationName: string;
  variationId: number;
  area: number;
}
